import React from "react";
import Dashboard from "@pages/admin/dashboard";
import TopPerformers from "@pages/admin/dashboard/top-performers";

import ZoneSetup from "@pages/admin/zone-setup";
import SubscriptionPackage from "@pages/admin/subscription-management/subscription-package";
import CreateSubscription from "@pages/admin/subscription-management/create";
import SubscriberList from "@pages/admin/subscription-management/subscriber-list";
import BusinessSettings from "@pages/admin/business-settings";
import PageSetup from "@pages/admin/page-setup";
import SupportChat from "@pages/admin/chat";
import CategorySetup from "@pages/admin/product-management/categories";
import BrandSetup from "@pages/admin/product-management/brands";
import ColorSetup from "@pages/admin/product-management/colors";
import AttributeSetup from "@pages/admin/product-management/attributes";
import ProductList from "@pages/admin/product-management/products/list";
import UserOverview from "@pages/admin/user-overview";
import SubAdmins from "@pages/admin/user-overview/sub-admins";
import CreateSubAdmin from "@pages/admin/user-overview/sub-admins/CreateSubAdmin";
import RolesAdminPage from "@pages/admin/roles";
import CreateRole from "@pages/admin/roles/CreateRole";
import SurgePrice from "@pages/admin/zone-setup/surge-price";
import Modules from "@pages/admin/modules";
import ModuleForm from "@pages/admin/modules/form";
import UnitSetup from "@pages/admin/product-management/units";
import AllOrders from "@commons/orders/all";
import OrderPlaced from "@commons/orders/order-placed";
import OrderConfirmed from "@commons/orders/order-confirmed";
import OrderProcessing from "@commons/orders/order-processing";
import DeliveryAssigned from "@commons/orders/delivery-assigned";
import ReadyForPickup from "@commons/orders/ready-for-pickup";
import OrderPickedUp from "@commons/orders/order-picked-up";
import OutForDelivery from "@commons/orders/out-for-delivery";
import NearCustomer from "@commons/orders/near-customer";
import Delivered from "@commons/orders/delivered";
import PrescriptionRequested from "@commons/orders/prescription-requested";
import PrescriptionAccepted from "@commons/orders/prescription-accepted";
import CreatingInvoice from "@commons/orders/creating-invoice";
import InvoiceShared from "@commons/orders/invoice-shared";
import InvoiceAccepted from "@commons/orders/invoice-accepted";
import PrescriptionRejected from "@commons/orders/prescription-rejected";
import Cancelled from "@commons/orders/cancelled";
import Rejected from "@commons/orders/rejected";
import Invoice from "@commons/orders/individual-order-details/invoice";
import OrderDetails from "@commons/orders/individual-order-details/order-details";
import AdminBannerSetup from "@pages/admin/banner-settings";
import AdminCouponSetup from "@pages/admin/coupon-setup";
import AdminPushNotification from "@pages/admin/push-notifications";
import PendingDeliveryManRequest from "@commons/delivery-man-management/pending-requests";
import AddDeliveryMan from "@commons/delivery-man-management/form";
import DeliveryManList from "@commons/delivery-man-management/list";
import IndividualDelivery from "@commons/delivery-man-management/individual-delivery";
import StoreForm from "@commons/store-setup/form";
import StoreType from "@commons/store-setup/store-type";
import PendingStoreRequest from "@commons/store-setup/pending-requests";
import StoreList from "@commons/store-setup/list";
import IndividualStore from "@commons/store-setup/individual-store";
import CreateNewProduct from "@commons/store-setup/individual-store/product-setup/create";
import ViewProduct from "@commons/store-setup/individual-store/product-setup/view";
import Addons from "@pages/admin/product-management/add-ons";
import ShapeSetup from "@pages/admin/product-management/shapes";
import CreateProductForm from "@commons/store-setup/individual-store/product-setup/form/Main";
import DealsList from "@pages/admin/deals";
import DealsForm from "@pages/admin/deals/form";
import DealProducts from "@pages/admin/deals/products";
import ZoneWiseDeliverySettings from "@pages/admin/zone-setup/DeliveryCharges";
import AdminWithdrawalsPage from "@pages/admin/withdrawals";
import NotificationList from "@commons/push-notifications/list";
import NotificationsPage from "@pages/notifications";
import CustomerList from "@pages/admin/customers/list";
import CustomerDetails from "@pages/admin/customers/individual-customer";
import CollectCashPage from "@pages/admin/collect-cash";
import TransactionReport from "@pages/admin/transaction/reports/TransactionReport";
import TransactionDetails from "@pages/admin/transaction/reports/TransactionDetails";
import ItemReport from "@pages/admin/transaction/reports/ItemReport";
import StoreWiseReport from "@pages/admin/transaction/reports/StoreWiseReport";
import DeliveryWiseReport from "@pages/admin/transaction/reports/DeliveryWiseReport";
import DisbursementReport from "@pages/admin/transaction/reports/DisbursementReport";
import WalletLoadRequests from "@pages/admin/wallet-loads";
import DispatchPage from "@pages/admin/dispatch";
import POS from "@pages/store/pos";
import RedeemCodesTable from "@pages/admin/redeem-codes/Table";
import AdminPOS from "@pages/admin/pos";
import BackgroundTasks from "@pages/admin/product-management/products/background-tasks";
import AuditLogsPage from "@pages/admin/audit-logs";
export const adminRoutes = [
  {
    path: "audit-logs",
    Component: AuditLogsPage,
    exact: true,
  },
  {
    path: "pos",
    Component: AdminPOS,
    exact: true,
  },
  {
    path: "dispatch",
    Component: DispatchPage,
    exact: true,
  },
  {
    path: "transaction/collect-cash",
    Component: CollectCashPage,
    exact: true,
  },
  {
    path: "transaction/withdraw-request",
    Component: AdminWithdrawalsPage,
    exact: true,
  },
  {
    path: "transaction/transaction-report",
    Component: TransactionReport,
    exact: true,
  },
  {
    path: "transaction/details/:id",
    Component: TransactionDetails,
    exact: true,
  },
  {
    path: "transaction/wallet-load-requests",
    Component: WalletLoadRequests,
    exact: true,
  },
  {
    path: "transaction/item-report",
    Component: ItemReport,
    exact: true,
  },
  {
    path: "transaction/store-wise-report",
    Component: StoreWiseReport,
    exact: true,
  },
  {
    path: "transaction/delivery-wise-report",
    Component: DeliveryWiseReport,
    exact: true,
  },
  {
    path: "transaction/disbursement-report",
    Component: DisbursementReport,
    exact: true,
  },
  { path: "modules/list", Component: Modules, exact: true },
  { path: "modules/create", Component: ModuleForm, exact: true },
  { path: "modules/update/:id", Component: ModuleForm, exact: true },
  {
    path: "dashboard",
    Component: Dashboard,
    exact: true,
  },
  {
    path: "dashboard/top-performers",
    Component: TopPerformers,
    exact: true,
  },
  {
    path: "users",
    Component: UserOverview,
    exact: true,
  },
  {
    path: "users/sub-admins",
    Component: SubAdmins,
    exact: true,
  },
  {
    path: "users/sub-admins/create",
    Component: CreateSubAdmin,
    exact: true,
  },
  {
    path: "users/sub-admins/edit/:id",
    Component: CreateSubAdmin,
    exact: true,
  },
  {
    path: "roles",
    Component: RolesAdminPage,
    exact: true,
  },
  {
    path: "roles/create",
    Component: CreateRole,
    exact: true,
  },
  {
    path: "roles/edit/:id",
    Component: CreateRole,
    exact: true,
  },

  {
    path: "zone-setup",
    Component: ZoneSetup,
    exact: true,
  },
  {
    path: "zone-setup/:zoneId",
    Component: ZoneSetup,
    exact: true,
  },
  {
    path: "zone-setup/surge-price/:zoneId",
    Component: SurgePrice,
    exact: true,
  },
  {
    path: "zone-setup/delivery-charge/:zoneId",
    Component: ZoneWiseDeliverySettings,
    exact: true,
  },
  {
    path: "subscription-management/subscription-package",
    Component: SubscriptionPackage,
    exact: true,
  },
  {
    path: "subscription-management/subscription-package/create",
    Component: CreateSubscription,
    exact: true,
  },
  {
    path: "subscription-management/subscription-package/update/:id",
    Component: CreateSubscription,
    exact: true,
  },
  {
    path: "subscription-management/subscriber-list",
    Component: SubscriberList,
    exact: true,
  },
  {
    path: "banner-settings",
    Component: AdminBannerSetup,
    exact: true,
  },
  {
    path: "banner-settings/:id",
    Component: AdminBannerSetup,
    exact: true,
  },

  {
    path: "deals",
    Component: DealsList,
    exact: true,
  },
  {
    path: "deals/add",
    Component: DealsForm,
    exact: true,
  },
  {
    path: "deals/:id",
    Component: DealsForm,
    exact: true,
  },
  {
    path: "deals/:id/products",
    Component: DealProducts,
    exact: true,
  },

  {
    path: "users/store/add-store",
    Component: StoreForm,
    exact: true,
  },
  {
    path: "users/store/update-store/:id",
    Component: StoreForm,
    exact: true,
  },
  {
    path: "users/store/add-store-type",
    Component: StoreType,
    exact: true,
  },
  {
    path: "users/store/update-store-type/:id",
    Component: StoreType,
    exact: true,
  },
  {
    path: "users/store/pending-requests",
    Component: PendingStoreRequest,
    exact: true,
  },
  {
    path: "users/store/store-lists",
    Component: StoreList,
    exact: true,
  },
  {
    path: "users/store/store-lists/view/:storeId",
    Component: IndividualStore,
    exact: true,
  },
  {
    path: "users/store/create-product/:storeId",
    Component: CreateNewProduct,
    exact: true,
  },
  {
    path: "users/store/update-product/:productId",
    Component: CreateProductForm,
    exact: true,
  },
  {
    path: "coupon-setup",
    Component: AdminCouponSetup,
    exact: true,
  },
  {
    path: "coupon-setup/:id",
    Component: AdminCouponSetup,
    exact: true,
  },
  {
    path: "push-notifications",
    Component: AdminPushNotification,
    exact: true,
  },
  {
    path: "notifications",
    Component: NotificationsPage,
    exact: true,
  },
  {
    path: "business-settings",
    Component: BusinessSettings,
    exact: true,
  },
  {
    path: "page-setup",
    Component: PageSetup,
    exact: true,
  },
  {
    path: "chat",
    Component: SupportChat,
    exact: true,
  },
  {
    path: "chat/:params",
    Component: SupportChat,
    exact: true,
  },

  {
    path: "product-management/categories",
    Component: CategorySetup,
    exact: true,
  },
  {
    path: "product-management/categories/:categoryId",
    Component: CategorySetup,
    exact: true,
  },
  {
    path: "product-management/shapes",
    Component: ShapeSetup,
    exact: true,
  },
  {
    path: "product-management/shapes/:shapeId",
    Component: ShapeSetup,
    exact: true,
  },
  {
    path: "product-management/brands",
    Component: BrandSetup,
    exact: true,
  },
  {
    path: "product-management/brands/:brandId",
    Component: BrandSetup,
    exact: true,
  },

  {
    path: "product-management/colors",
    Component: ColorSetup,
    exact: true,
  },
  {
    path: "product-management/colors/:colorsId",
    Component: ColorSetup,
    exact: true,
  },
  {
    path: "product-management/attributes",
    Component: AttributeSetup,
    exact: true,
  },
  {
    path: "product-management/attributes/:attributeId",
    Component: AttributeSetup,
    exact: true,
  },
  {
    path: "product-management/units",
    Component: UnitSetup,
    exact: true,
  },
  {
    path: "product-management/units/:units",
    Component: UnitSetup,
    exact: true,
  },
  {
    path: "product-management/products",
    Component: ProductList,
    exact: true,
  },
  {
    path: "product-management/products/background-tasks",
    Component: BackgroundTasks,
    exact: true,
  },
  {
    path: "product-management/add-ons",
    Component: Addons,
    exact: true,
  },
  {
    path: "users/delivery-man/pending-requests",
    Component: PendingDeliveryManRequest,
    exact: true,
  },
  {
    path: "users/delivery-man/add-delivery-man",
    Component: AddDeliveryMan,
    exact: true,
  },
  {
    path: "users/delivery-man/update-delivery-man/:id",
    Component: AddDeliveryMan,
    exact: true,
  },
  {
    path: "users/delivery-man/delivery-man-lists",
    Component: DeliveryManList,
    exact: true,
  },
  {
    path: "users/delivery-man/delivery-man-lists/view/:id",
    Component: IndividualDelivery,
    exact: true,
  },
  {
    path: "users/customer/customer-lists",
    Component: CustomerList,
    exact: true,
  },
  {
    path: "users/customer/customer-lists/view/:id",
    Component: CustomerDetails,
    exact: true,
  },
  {
    path: "orders/all",
    Component: AllOrders,
    exact: true,
  },
  {
    path: "orders/order-placed",
    Component: OrderPlaced,
    exact: true,
  },
  {
    path: "orders/order-confirmed",
    Component: OrderConfirmed,
    exact: true,
  },
  {
    path: "orders/order-processing",
    Component: OrderProcessing,
    exact: true,
  },
  {
    path: "orders/delivery-assigned",
    Component: DeliveryAssigned,
    exact: true,
  },
  {
    path: "orders/ready-for-pickup",
    Component: ReadyForPickup,
    exact: true,
  },
  {
    path: "orders/order-picked-up",
    Component: OrderPickedUp,
    exact: true,
  },
  {
    path: "orders/out-for-delivery",
    Component: OutForDelivery,
    exact: true,
  },
  {
    path: "orders/near-customer",
    Component: NearCustomer,
    exact: true,
  },
  {
    path: "orders/delivered",
    Component: Delivered,
    exact: true,
  },
  {
    path: "orders/prescription-requested",
    Component: PrescriptionRequested,
    exact: true,
  },
  {
    path: "orders/prescription-accepted",
    Component: PrescriptionAccepted,
    exact: true,
  },
  {
    path: "orders/creating-invoice",
    Component: CreatingInvoice,
    exact: true,
  },
  {
    path: "orders/invoice-shared",
    Component: InvoiceShared,
    exact: true,
  },
  {
    path: "orders/invoice-accepted",
    Component: InvoiceAccepted,
    exact: true,
  },
  {
    path: "orders/prescription-rejected",
    Component: PrescriptionRejected,
    exact: true,
  },
  {
    path: "orders/cancelled",
    Component: Cancelled,
    exact: true,
  },
  {
    path: "orders/rejected",
    Component: Rejected,
    exact: true,
  },
  {
    path: "orders/details/:id",
    Component: OrderDetails,
    exact: true,
  },
  {
    path: "orders/invoice/:id",
    Component: Invoice,
    exact: true,
  },
  {
    path: "products/view/:productId",
    Component: ViewProduct,
    exact: true,
  },
  {
    path: "pos/:orderId",
    Component: POS,
    exact: true,
  },
  {
    path: "redeem-codes",
    Component: RedeemCodesTable,
    exact: true,
  },
  {
    path: "redeem-codes/export/:jobId",
    Component: React.lazy(
      () => import("@pages/admin/redeem-codes/ExportProgress"),
    ),
    exact: true,
  },
];
//commit
